import { FC, ReactNode } from "react";

import { Box, Stack } from "@mui/material";

import AssistantAvatar from "@/icons/illustration/data-reporting-assistant-chat.svg";

interface AssistantBubbleProps {
  children: ReactNode;
  "data-test"?: string;
}

export const AssistantBubble: FC<AssistantBubbleProps> = ({ children, "data-test": dataTest }) => (
  <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ pr: 5 }} data-test={dataTest}>
    <Box
      component={AssistantAvatar}
      viewBox="0 0 40 40"
      aria-hidden
      sx={(theme) => ({ flexShrink: 0, width: theme.spacing(5), height: theme.spacing(5) })}
    />
    <Stack spacing={1} sx={{ flex: 1, minWidth: 0 }}>
      {children}
    </Stack>
  </Stack>
);
